import { Select } from "../../uikit";
import { useEffect, useMemo } from "react";

import { useTranslation } from "react-i18next";
import { AnimatePresence, motion } from "motion/react";
import { opacityVariants } from "../../routesVariants";
import {
  getCountryEmoji,
  sortServersForDisplay,
  translateCity,
} from "../../utils/serverDisplay";

import styles from "./guides.module.css";

const GuideHostnameData = ({
  subscription,
  servers,
  label,
  selectedHostname,
  setSelectedHostname,
}) => {
  const { t, i18n } = useTranslation();
  const hasLabel = (label || "").trim() !== "";
  const resolvedLabel = (label || "").trim() || t("Connection server");
  const getServerHostname = (server) =>
    server.hostname || server.domain || server.name || "";

  const sortedServers = useMemo(() => {
    return sortServersForDisplay(servers, {
      preferredServerName: subscription?.last_exit_server_name,
    });
  }, [servers, subscription?.last_exit_server_name]);

  const formatServerLabel = (server) => {
    const country = getCountryEmoji(server.country_code);
    const city = translateCity(
      server.city || server.location || "",
      server.city_ru,
      i18n.resolvedLanguage,
    );
    const name = server.name || server.hostname || "";
    const location = [country, city].filter(Boolean).join(" ");
    return [location, name].filter(Boolean).join(" - ");
  };

  useEffect(() => {
    if (sortedServers.length) {
      setSelectedHostname((current) => {
        if (
          current &&
          sortedServers.some((server) => getServerHostname(server) === current)
        ) {
          return current;
        }
        return getServerHostname(sortedServers[0]);
      });
    }
  }, [sortedServers]);

  const setSelectedHostnameHandler = (event) => {
    setSelectedHostname(event.target.value);
  };

  const containerClassName = `${styles.container} ${styles["min-height"]} ${
    sortedServers.length <= 1
      ? hasLabel
        ? styles["with-label"]
        : styles["without-label"]
      : styles["without-label"]
  }`;

  return (
    <div className={containerClassName}>
      {sortedServers.length > 1 && (
        <div className={`${styles["bg-all"]}`}>
          <Select className={styles.bg} onChange={setSelectedHostnameHandler}>
            {sortedServers.map((row) => {
              const hostname = getServerHostname(row);
              return (
                <option value={hostname} selected={hostname === selectedHostname}>
                  {formatServerLabel(row)}
                </option>
              );
            })}
          </Select>
        </div>
      )}
      {selectedHostname && (
        <div className={styles.row}>
          <div className="column">
            <div className={`${styles.wrap} label mb-025`}>
              <div className={`${styles.wrap} label mb-025`}>
                {resolvedLabel}
              </div>
            </div>
            <AnimatePresence exitBeforeEnter>
              <motion.div
                key={selectedHostname}
                className="flex"
                variants={opacityVariants}
                initial="initial"
                animate="final"
                exit="exit"
              >
                <div className={`${styles.wrap} bold`}>{selectedHostname}</div>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      )}
    </div>
  );
};

export default GuideHostnameData;
